/* src/app/master-data/roles/list-roles/list-roles.component.css */
/*# sourceMappingURL=list-roles.component-WV2ZV6FV.css.map */
